export default function Orders() {
  return (
    <div className="container mt-5">
      <h1>Welcome to Order</h1>
    </div>
  );
}
